/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_route_details__expense_note_section__edit__allowance = /** @type {(inputs: {}) => string} */ () => {
	return `Pauschal`
};

const en_route_details__expense_note_section__edit__allowance = /** @type {(inputs: {}) => string} */ () => {
	return `Allowance`
};

const es_route_details__expense_note_section__edit__allowance = /** @type {(inputs: {}) => string} */ () => {
	return `A tanto alzado`
};

const fr_route_details__expense_note_section__edit__allowance = /** @type {(inputs: {}) => string} */ () => {
	return `Au forfait`
};

const it_route_details__expense_note_section__edit__allowance = /** @type {(inputs: {}) => string} */ () => {
	return `Forfait`
};

const nl_route_details__expense_note_section__edit__allowance = /** @type {(inputs: {}) => string} */ () => {
	return `Voor een vast bedrag`
};

const pt_route_details__expense_note_section__edit__allowance = /** @type {(inputs: {}) => string} */ () => {
	return `Subsídios`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const route_details__expense_note_section__edit__allowance = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.route_details__expense_note_section__edit__allowance(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("route_details__expense_note_section__edit__allowance", locale)
	if (locale === "de") return de_route_details__expense_note_section__edit__allowance(inputs)
	if (locale === "en") return en_route_details__expense_note_section__edit__allowance(inputs)
	if (locale === "es") return es_route_details__expense_note_section__edit__allowance(inputs)
	if (locale === "fr") return fr_route_details__expense_note_section__edit__allowance(inputs)
	if (locale === "it") return it_route_details__expense_note_section__edit__allowance(inputs)
	if (locale === "nl") return nl_route_details__expense_note_section__edit__allowance(inputs)
	return pt_route_details__expense_note_section__edit__allowance(inputs)
};